import React, { useEffect, useState, useRef } from 'react';
import {
  Row,
  Col,
  Select,
  Button,
} from 'antd';
import moment from 'moment';
import { CheckSquareTwoTone } from '@ant-design/icons/lib';
import { FlexGridSearch } from '@grapecity/wijmo.react.grid.search';
import * as wjInput from '@grapecity/wijmo.react.input';
import { FlexGrid, FlexGridColumn, FlexGridCellTemplate } from '@grapecity/wijmo.react.grid';
import { FlexGridFilter } from '@grapecity/wijmo.react.grid.filter';
import * as wijmo from '@grapecity/wijmo';
import * as wjcGridPdf from '@grapecity/wijmo.grid.pdf';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjcPdf from '@grapecity/wijmo.pdf';
import '@grapecity/wijmo.styles/wijmo.css';
import { CollectionView, Globalize } from '@grapecity/wijmo';
import { CollectionViewNavigator } from '@grapecity/wijmo.react.input';
import { FolderOpenTwoTone } from '@ant-design/icons/lib';

let flexes = '';
let showGrid = '';
let listBoxes = '';
let i = 1;

class ExportService {
  startExcelExport(flex, successCallback, errorCallback, progressCallback) {
    wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
      flex,
      {
        includeColumnHeaders: true,
        includeStyles: false
        // formatItem: this._formatExcelItem
      },
      'TestDetail_BackgroundScreening.xlsx',
      successCallback,
      errorCallback,
      progressCallback,
      true
    );
  }
  cancelExcelExport(doneCollback) {
    wjcGridXlsx.FlexGridXlsxConverter.cancelAsync(doneCollback);
  }
  exportToPdf(flex, options) {
    wjcGridPdf.FlexGridPdfConverter.export(flex, 'FlexGrid.pdf', {
      maxPages: 100,
      exportMode: wjcGridPdf.ExportMode.All,
      scaleMode: wjcGridPdf.ScaleMode.ActualSize,
      documentOptions: {
        pageSettings: {
          layout: wjcPdf.PdfPageOrientation.Landscape
        },
        header: {
          declarative: {
            text: '\t&[Page]\\&[Pages]'
          }
        },
        footer: {
          declarative: {
            text: '\t&[Page]\\&[Pages]'
          }
        }
      },
      styles: {
        cellStyle: {
          backgroundColor: '#ffffff',
          borderColor: '#c6c6c6'
        },
        altCellStyle: {
          backgroundColor: '#f9f9f9'
        },
        groupCellStyle: {
          backgroundColor: '#dddddd'
        },
        headerCellStyle: {
          backgroundColor: '#eaeaea'
        },
        // Highlight Invalid Cells
        errorCellStyle: {
          backgroundColor: 'rgba(255, 0, 0, 0.3)'
        }
      },
      customCellContent: false
      // formatItem: (e) => this._formatPdfItem(e, options)
    });
  }

  _resetExcelContext(ctx) {
    ctx.exporting = false;
    ctx.progress = 0;
    ctx.preparing = false;
  }
}

const BackgroundScreeningTab = ({
  data,
  docBgScreenPermission,
  downloadUrlResultAttach,
  downloadAuthorization,
  hideResultColumn = false
}) => {
  const [view, setView] = useState();
  const [viewData, setViewData] = useState();
  const [viewIndex, setViewIndex] = useState(0);
  const [viewCount, setViewCount] = useState(0);
  const [pagging, setPagging] = useState(10);
  const [isExcelExporting, setIsExcelExporting] = useState();
  const [isExcelPreparing, setIsExcelPreparing] = useState();
  const [excelProgress, setExcelProgress] = useState();
  const [listboxColumns, setListboxColumns] = useState([]);
  const [pagginationNumRecord, setPagginationNumRecord] = useState({});
  const [backgroundScreeningData, setBackgroundScreeningData] = useState([]);
  const [itemsPerPage, setItemPerPage] = useState(10);
  const [pageApply, setPageApply] = useState(false);
  const theGrid = useRef();
  const theSearch = useRef();
  const fixedContainerRef = useRef(null);
  const [pageSize, setPageSize] = useState(10);
  const filterRefCounter = useRef(null);

  useEffect(() => {
    console.log('drug alcohol table data', data);
    const ress = data.map((val) => {
      return {
        ...val,
        newEmail: val.email ? val.email : '',
        newOrderDate: val.create_date ? moment(val.create_date).format('YYYY/MM/DD') : '',
        newLocation:
          val.child_ids.length > 0 && val.company.length > 0
            ? val.child_ids[1].toString().replace(val.company[1].toString() + ', ', '')
            : ''
      };
    });

    setBackgroundScreeningData(ress);
    // setWijmoFlexGrid(ress, 10);
  }, []);

  useEffect(() => {
    if (backgroundScreeningData.length > 0) {
      const collectionView1 = new CollectionView(backgroundScreeningData, {
        pageSize: backgroundScreeningData.length
      });
      setViewData(collectionView1);
      const collectionView2 = new CollectionView(backgroundScreeningData, {
        pageSize: pageSize,
        collectionChanged: (s) => {
          filterRefCounter.current = s.totalItemCount;
          var filterCounter = document.getElementById('filterCounter');
          if (filterCounter) {
            filterCounter.textContent = s.totalItemCount;
          }
        }
      });
      setView(collectionView2);
    }
  }, [backgroundScreeningData, pageSize]);

  let theGrids = theGrid.current;
  let theSearchs = theSearch.current;
  if (theGrids && theSearchs) {
    theSearchs.control.grid = theGrids.control;
    console.log('the searches', (theSearchs.grid = theGrids));
  }

  /* Wijmo pagesize set functionality */
  const paggination = (value) => {
    setItemPerPage(value);
    setPageSize(value);
    view.refresh();
  };

  // const paggination = (value) => {
  //   console.log('page value', value);
  //   setItemPerPage(value);
  //   setPageApply(true);
  //   // setPagging(value);
  //   // this.setState({ pagging: e.target.value})
  //   setTimeout(() => {
  //     setWijmoFlexGrid(backgroundScreeningData, value);
  //   }, 500);
  // };
  // const setWijmoFlexGrid = (data, page) => {
  //   console.log('pagging', data, page);
  //   let views = new wijmo.CollectionView(data, { pageSize: Number(page) });
  //   let viewsData = new wijmo.CollectionView(data, { pageSize: Number(data && data.length) });
  //   console.log('views', views);
  //   setView(views);
  //   setViewData(viewsData);
  //   setViewIndex(views.pageIndex + 1);
  //   setViewCount(views.pageCount);
  //   //pagination records
  //   setTimeout(() => {
  //     setPagginationNumRecord({
  //       currentRecord: document.querySelectorAll('.backgroundtab .wj-cells .wj-row').length - 1,
  //       totalRecord: data.length
  //     });
  //   }, 2000);
  // };

  // function _createItemsSource(counter) {
  //   // const data = this.props.dataService.getData(counter);
  //   const view = new wjCore.CollectionView(table, {
  //       getError: (item, prop) => {
  //           const displayName = flexes.columns.getColumn(prop).header;
  //           // return this.props.dataService.validate(item, prop, displayName);
  //       }
  //   });
  //   view.collectionChanged.addHandler((s, e) => {
  //     // initializes new added item with a history data
  //     if (e.action === wjCore.NotifyCollectionChangedAction.Add) {
  //         e.item.history = this.props.dataService.getHistoryData();
  //         e.item.id = this._lastId;
  //         this._lastId++;
  //     }
  // });
  // return view;
  // }

  const exportToExcel = () => {
    const exportService = new ExportService();
    // const { isExcelPreparing: preparing, isExcelExporting: exporting } = this.state;
    const resetState = () => {
      setIsExcelPreparing(false);
      setIsExcelExporting(false);
      setExcelProgress(0);
    };
    if (!isExcelPreparing && !isExcelExporting) {
      setIsExcelPreparing(true);
      exportService.startExcelExport(
        flexes,
        () => {
          console.log('Export to Excel completed');
          resetState();
        },
        (err) => {
          console.error(`Export to Excel failed: ${err}`);
          resetState();
        },
        (prg) => {
          setIsExcelPreparing(false);
          setIsExcelExporting(true);
          setExcelProgress(prg);
        }
      );
      console.log('Export to Excel started');
    } else {
      exportService.cancelExcelExport((progress) => {
        console.log('Export to Excel canceled');
        resetState();
      });
    }
  };

  const initializedListBox = (listbox) => {
    listBoxes = listbox;
  };

  const showPicker = (e) => {
    console.log('grids.hostelement', showGrid);
    // show the column picker when the user clicks the top-left cell
    const reference = showGrid.hostElement.querySelector('.wj-topleft');
    wijmo.showPopup(listBoxes.hostElement, reference, false, true, false);
    listBoxes.focus();
    e.preventDefault();
  };
  const hidePicker = () => {
    wijmo.hidePopup(listBoxes.hostElement);
  };

  const formatItem = (sender, e) => {
    // var self = this;
    // console.log("inside formatitem",e.panel)
    // console.log("sender.topLeftCells",sender.topLeftCells)
    // console.log("aaaaaaaaaaa",sender.topLeftCells===e.panel)
    // const vaccinations_filter = vaccineTable.map((value)=>{
    //   return value.vaccination.map((v, i) => (
    //       v.vacData
    //   ))
    // })
    // console.log("create_date_filter",vaccinations_filter)

    // let filterRatings = filter.getColumnFilter("vaccination");
    // filterRatings.valueFilter.uniqueValues = vaccinations_filter;

    if (e.panel == sender.topLeftCells) {
      var span = document.createElement('span');
      span.className = 'column-picker-icon glyphicon glyphicon-cog';
      span.innerHTML = '&#9733';
      span.style.color = '#425a81';
      span.addEventListener('mousedown', function (e) {
        console.log('calliing show picker');
        showPicker(e);
      });
      e.cell.appendChild(span);
    }

    //for custom height of cells
    const flex = sender,
      col = flex.columns[e.col],
      row = flex.rows[e.row];
    if (row) {
      row.height = 38; // You can adjust the height as needed
    }
  };

  const gridInitialized = (ctl) => {
    ctl.select(-1, -1);
    showGrid = ctl;
    // flexes = ctl;
    // console.log('filter filter', filter);

    // var filter = new wjcGridFilter.FlexGridFilter(flexes);
    // console.log('filter', filter);
    // filter.getColumnFilter('create_date').valueFilter.maxValues = 3000;
    setListboxColumns(ctl.columns);
  };

  const gridInitializedData = (ctl) => {
    flexes = ctl;
  };

  // const showEmail = (item) => {
  //   console.log("item.item.email",item.item.email ? item.item.email : 'ddd',item.item.email)
  //   return <span>{item.item.email ? item.item.email : ''}</span>;
  // };

  const showLocation = (item) => {
    return (
      <p>
        {item.item.child_ids.length > 0 && item.item.company.length > 0
          ? item.item.child_ids[1].toString().replace(item.item.company[1].toString() + ', ', '')
          : ''}
      </p>
    );
  };

  const showPackageName = (item) => {
    return <p>{item.item.package_name ? item.item.package_name[1] : ''}</p>;
  };

  const showOrderDate = (item) => {
    return <p>{item.item.create_date ? moment(item.item.create_date).format('YYYY/MM/DD') : ''}</p>;
  };

  const showStatus = (item) => {
    return <p>{item.item.status ? item.item.status : ''}</p>;
  };

  // const showAuth = (item) => {
  //   return (
  //     <span className='nowrap'>
  //       {docBgScreenPermission && item.item.attachment_id ? (
  //         <button
  //           className='doclink'
  //           style={{
  //             border: 'none',
  //             textAlign: 'center',
  //             borderRadius: 5,
  //             backgroundColor: '#abc',
  //             fontWeight: 'bold'
  //           }}
  //           onClick={(e) => downloadAuthorization(e, [item.item.attachment_id])}
  //         >
  //           Preview
  //         </button>
  //       ) : (
  //         item.item.attachment_id && <CheckSquareTwoTone style={{ color: 'green', fontSize: 20 }} />
  //       )}
  //     </span>
  //   );
  // };
  const showAuth = (item) => {
    return (
      <span className='nowrap'>
        {item.item.attachment_id ? (
          // <p style={{color:'blue'}}>
          //   Preview
          <FolderOpenTwoTone
            twoToneColor='#cc7a00'
            style={{ fontSize: '16px', cursor: 'pointer', marginLeft: '10px' }}
            onClick={(e) => downloadAuthorization(e, [item.item.attachment_id])}
          />
          // </p>
        ) : (
          item.item.attachment_id && <CheckSquareTwoTone style={{ color: 'green', fontSize: 15 }} />
        )}
      </span>
    );
  };
  // const showResult = (item) => {
  //   return (
  //     <span className='nowrap'>
  //       {docBgScreenPermission && item.item.result_attach ? (
  //         <button
  //           className='doclink'
  //           style={{
  //             border: 'none',
  //             textAlign: 'center',
  //             borderRadius: 5,
  //             backgroundColor: '#abc',
  //             fontWeight: 'bold'
  //           }}
  //           onClick={(e) => downloadUrlResultAttach(e, item.item.result_attach)}
  //         >
  //           Preview
  //         </button>
  //       ) : (
  //         item.item.result_attach && <CheckSquareTwoTone style={{ color: 'green', fontSize: 20 }} />
  //       )}
  //     </span>
  //   );
  // };

  const showResult = (item) => {
    return (
      <span className='nowrap'>
        {docBgScreenPermission && item.item.result_attach ? (
          // <p style={{color:'blue'}}>
          //   Preview
          <FolderOpenTwoTone
            twoToneColor='#cc7a00'
            style={{ fontSize: '16px', cursor: 'pointer', marginLeft: '10px' }}
            onClick={(e) => downloadUrlResultAttach(e, item.item.result_attach)}
          />
          // </p>
        ) : (
          item.item.result_attach && <CheckSquareTwoTone style={{ color: 'green', fontSize: 15 }} />
        )}
      </span>
    );
  };

  const showResultURL = (item) => {
    return docBgScreenPermission && item.item.result_url && item.item.result_url.length > 0 ? (
      <a target='_blank' href={item.item.result_url}>
        Result
      </a>
    ) : (
      <CheckSquareTwoTone style={{ color: 'green', fontSize: 15 }} />
    );
  };

  // const updateViewPager = (target) => {
  //   console.log('target', target);
  //   let btn = wijmo.closest(target, 'button'),
  //     id = btn ? btn.id : '';
  //   switch (id) {
  //     case 'btnFirst':
  //       i = 1;
  //       view.moveToFirstPage();
  //       setTimeout(() => {
  //         setPagginationNumRecord({
  //           currentRecord: document.querySelectorAll('.backgroundtab .wj-cells .wj-row').length - 1,
  //           totalRecord: backgroundScreeningData.length
  //         });
  //       }, 1000);
  //       break;
  //     case 'btnPrev':
  //       if (i <= 1) {
  //         i = 1;
  //       } else {
  //         var a = Math.ceil(backgroundScreeningData.length / itemsPerPage);
  //         view.moveToPreviousPage();
  //         if (a === i) {
  //           setPagginationNumRecord({
  //             currentRecord:
  //               backgroundScreeningData.length -
  //               (document.querySelectorAll('.backgroundtab .wj-cells .wj-row').length - 1),
  //             totalRecord: backgroundScreeningData.length
  //           });
  //         } else {
  //           setPagginationNumRecord({
  //             currentRecord: pagginationNumRecord.currentRecord - itemsPerPage,
  //             totalRecord: backgroundScreeningData.length
  //           });
  //         }
  //         i--;
  //       }
  //       break;
  //     case 'btnNext':
  //       if (pageApply) {
  //         if (
  //           backgroundScreeningData.length ===
  //           document.querySelectorAll('.backgroundtab .wj-cells .wj-row').length - 1
  //         ) {
  //         } else {
  //           i = 2;
  //         }
  //         setPageApply(false);
  //       } else {
  //         if (i >= Math.ceil(backgroundScreeningData.length / itemsPerPage)) {
  //         } else {
  //           i++;
  //           console.log('inside i++');
  //         }
  //       }
  //       var a = Math.ceil(backgroundScreeningData.length / itemsPerPage);
  //       if (a === i) {
  //         setPagginationNumRecord({
  //           currentRecord: backgroundScreeningData.length,
  //           totalRecord: backgroundScreeningData.length
  //         });
  //       } else {
  //         setPagginationNumRecord({
  //           currentRecord:
  //             (document.querySelectorAll('.backgroundtab .wj-cells .wj-row').length - 1) * i,
  //           totalRecord: backgroundScreeningData.length
  //         });
  //       }
  //       view.moveToNextPage();
  //       break;
  //     case 'btnLast':
  //       i = Math.ceil(backgroundScreeningData.length / itemsPerPage);
  //       view.moveToLastPage();
  //       setPagginationNumRecord({
  //         currentRecord: backgroundScreeningData.length,
  //         totalRecord: backgroundScreeningData.length
  //       });
  //       break;
  //   }
  //   setViewIndex(view.pageIndex + 1);
  //   setViewCount(view.pageCount);
  // };

  return (
    <div>
      <Row gutter={[32, 32]}>
        <Col xs={24} sm={8} md={8} lg={8} xl={10}>
          <FlexGridSearch
            ref={theSearch}
            placeholder='Search'
            cssMatch=''
            style={{ width: '70%', height: '40px' }}
          />
        </Col>

        <Col xs={12} sm={8} md={8} lg={8} xl={4} style={{ textAlign: 'center' }}>
          <div ref={fixedContainerRef}>
            {/* <p style={{ marginTop: '10px' }}>Items per page:</p> */}
            {/* <label for="range">Items per page:</label> */}
            {/* <select 
                            style={{width:'100px',borderRadius:0}}
                            options={[
                              { label: 10, value: 10 },
                              { label: 20, value: 20 },
                              { label: 50, value: 50 }
                            ]}
                          /> */}
            {/* <select name="range" id='range' value={pagging} onChange={paggination} >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                          </select> */}

            {/* <Select
              // showSearch
              style={{ width: 160 }}
              placeholder={`Items per page: ${pagging}`}
              // optionFilterProp='children'
              onChange={paggination}
              options={[
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 }
              ]}
              getPopupContainer={() => fixedContainerRef.current}
            /> */}
            <Select
              style={{ width: 170 }}
              placeholder={`Items per page : ${pageSize}`}
              onChange={paggination}
              options={[
                { label: 'Items per page : 10', value: 10 },
                { label: 'Items per page : 20', value: 20 },
                { label: 'Items per page : 50', value: 50 }
              ]}
              getPopupContainer={() => fixedContainerRef.current}
            />
          </div>
        </Col>

        <Col xs={12} sm={8} md={8} lg={8} xl={10}>
          <Button
            type='primary'
            size='small'
            style={{ backgroundColor: '#3d586a', float: 'right' }}
            disabled={isExcelPreparing}
            onClick={exportToExcel}
          >
            {isExcelExporting ? `Cancel (${excelProgress}% done)` : 'Export To Excel'}
          </Button>
        </Col>
      </Row>

      {/* to export entire data of table */}
      <FlexGrid
        ref={theGrid}
        style={{ display: 'none' }}
        className='dummyWijmoData'
        itemsSource={viewData}
        initialized={gridInitializedData}
        formatItem={formatItem}
        isReadOnly={true}
      >
        {/* <FlexGridColumn binding='newEmail' header='Email' minWidth={200} width='*'/> */}
        <FlexGridColumn binding='newLocation' header='Location' minWidth={200} width='*' />
        <FlexGridColumn binding='newOrderDate' header='Ordered date' minWidth={140} width='*'>
          <FlexGridCellTemplate cellType='Cell' template={showOrderDate} />
        </FlexGridColumn>
        <FlexGridColumn binding='status' header='Status'>
          <FlexGridCellTemplate cellType='Cell' template={showStatus} />
        </FlexGridColumn>
        <FlexGridColumn binding='package_name' header='Package Name' minWidth={150} width='*'>
          <FlexGridCellTemplate cellType='Cell' template={showPackageName} />
        </FlexGridColumn>
        <FlexGridColumn
          binding='attachment_id'
          header='Authorization'
          // width='11*'
          // minWidth={150}
          // width='*'
          width={115}
        >
          <FlexGridCellTemplate cellType='Cell' template={showAuth} />
        </FlexGridColumn>
        {!hideResultColumn && (
          <FlexGridColumn binding='result_attach' header='Result' width={95}>
            <FlexGridCellTemplate cellType='Cell' template={showResult} />
          </FlexGridColumn>
        )}
        {!hideResultColumn && (
          <FlexGridColumn binding='result_url' header='Result URL' width={250}>
            <FlexGridCellTemplate cellType='Cell' template={showResultURL} />
          </FlexGridColumn>
        )}
      </FlexGrid>

      <FlexGrid
        // autoRowHeights={true}
        autoGenerateColumns={false}
        ref={theGrid}
        id='theGridTallRows'
        className='backgroundtab cliniclisttable'
        alternatingRowStep={1}
        itemsSource={view}
        initialized={gridInitialized}
        formatItem={formatItem}
        itemsPerPage={10}
        isReadOnly={true}
      >
        <div style={{ display: 'none' }}>
          <wjInput.ListBox
            className='column-picker'
            itemsSource={listboxColumns}
            checkedMemberPath='visible'
            displayMemberPath='header'
            lostFocus={hidePicker}
            initialized={initializedListBox}
          ></wjInput.ListBox>
        </div>
        {/* <FlexGridColumn binding='email' header='Email' minWidth={200} width='*'>
          <FlexGridCellTemplate cellType='Cell' template={showEmail} />
        </FlexGridColumn> */}
        <FlexGridColumn binding='newLocation' header='Location' width={260}>
          <FlexGridCellTemplate cellType='Cell' template={showLocation} />
        </FlexGridColumn>
        <FlexGridColumn binding='newOrderDate' header='Ordered date' width={168}>
          <FlexGridCellTemplate cellType='Cell' template={showOrderDate} />
        </FlexGridColumn>
        <FlexGridColumn
          binding='status'
          header='Status'
          // width='11*'
          // minWidth={150}
          // width='*'
          width={168}
        >
          <FlexGridCellTemplate cellType='Cell' template={showStatus} />
        </FlexGridColumn>
        <FlexGridColumn binding='package_name' header='Package Name' width={230}>
          <FlexGridCellTemplate cellType='Cell' template={showPackageName} />
        </FlexGridColumn>
        <FlexGridColumn
          binding='attachment_id'
          header='Authorization'
          // width='11*'
          // minWidth={150}
          // width='*'
          width={168}
        >
          <FlexGridCellTemplate cellType='Cell' template={showAuth} />
        </FlexGridColumn>

        {!hideResultColumn && (
          <FlexGridColumn binding='result_attach' header='Result' width={168}>
            <FlexGridCellTemplate cellType='Cell' template={showResult} />
          </FlexGridColumn>
        )}
        {!hideResultColumn && (
          <FlexGridColumn binding='result_url' header='Result URL' width={107}>
            <FlexGridCellTemplate cellType='Cell' template={showResultURL} />
          </FlexGridColumn>
        )}

        <FlexGridFilter
          filterColumns={[
            'email',
            'newLocation',
            'package_name',
            'newOrderDate',
            'status',
            ...(hideResultColumn ? [] : ['result_attach'])
            // 'result_url'
          ]}
        />
      </FlexGrid>

      {/* <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          onClick={(e) => updateViewPager(e.target)}
          style={{
            backgroundColor: '#425a81',
            color: '#fff',
            display: 'inline',
            borderRadius: '5px',
            // paddingTop: '4px',
            height: '30px'
          }}
        >
          <button
            id='btnFirst'
            style={{ color: '#fff', backgroundColor: '#425a81', height: '30px' }}
            className='btn'
          >
            <span className='wj-glyph-step-backward'></span>
          </button>
          <button
            id='btnPrev'
            className='btn'
            style={{ color: '#fff', backgroundColor: '#425a81', height: '30px' }}
          >
            <span className='wj-glyph-left'></span>
          </button>
          <p style={{ display: 'inline', fontSize: '13px' }}>
            &nbsp;&nbsp;&nbsp;Page {viewIndex} of {viewCount}&nbsp;&nbsp;&nbsp;
          </p>
          <button
            id='btnNext'
            className='btn'
            style={{ color: '#fff', backgroundColor: '#425a81', height: '30px' }}
          >
            <span className='wj-glyph-right'></span>
          </button>
          <button
            id='btnLast'
            className='btn'
            style={{ color: '#fff', backgroundColor: '#425a81', height: '30px' }}
          >
            <span className='wj-glyph-step-forward'></span>
          </button>
        </div>
        {pagginationNumRecord.currentRecord !== undefined ? (
          <p style={{ fontWeight: 'bold', fontSize: '15px' }}>
            {' '}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {`${pagginationNumRecord.currentRecord} out of ${pagginationNumRecord.totalRecord}`}
          </p>
        ) : (
          ''
        )}
      </div> */}
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        <div
          style={{
            backgroundColor: '#425a81',
            color: '#fff',
            display: 'inline',
            borderRadius: '5px',
            height: '30px'
          }}
        >
          <CollectionViewNavigator
            style={{ color: '#fff', backgroundColor: '#425a81', height: '30px' }}
            headerFormat='Page {currentPage:n0} of {pageCount:n0}'
            byPage={true}
            cv={view}
          />
        </div>
        &nbsp;&nbsp;&nbsp;
        <p
          style={{ fontWeight: 'bold', verticalAlign: 'baseline', fontSize: '14px' }}
          ref={filterRefCounter}
          id='filterCounter'
        >
          {Globalize.format(filterRefCounter.current, 'n0')}
        </p>
        &nbsp;
        <p style={{ fontWeight: 'bold', verticalAlign: 'baseline', fontSize: '14px' }}>
          {' '}
          out of {backgroundScreeningData.length}
        </p>
      </div>
    </div>
  );
};

export default BackgroundScreeningTab;
